export const isFormValid = (formElements: any): any => {
  if (typeof formElements === 'object' && formElements !== null) {
    return Object.entries(formElements).every(([key, formElement]: [string, any]) => {
      const { value, errors, isMandatory } = formElement;
      const isHavingError = errors?.length > 0;
      const isFalsyValue = value === undefined || value === null || value === '';

      if (!isMandatory) {
        return true;
      } else if (isHavingError) {
        return false;
      } else if (isMandatory && isFalsyValue) {
        return false;
      }
      return !!value;
    });
  }
};
